import { render, staticRenderFns } from "./baseBlockComponent.vue?vue&type=template&id=3aeaa776&"
import script from "./baseBlockComponent.vue?vue&type=script&lang=js&"
export * from "./baseBlockComponent.vue?vue&type=script&lang=js&"
import style0 from "./baseBlockComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports